// Blog content lives in JSON so it can be used by both:
// - the React app
// - build-time scripts (SEO prerendering)
import postsData from './posts.json';

// Posts marked "draft": true stay in the JSON for later review but are never published.
export const posts = postsData.filter((p) => !p.draft);

export function getAllPosts() {
  return [...posts].sort(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
  );
}

export function getPostBySlug(slug) {
  return posts.find((p) => p.slug === slug) || null;
}
